import {
  newsletterReducer,
  wishlistMetaReducer,
} from '@travel-frontend/ui-components';
import {combineReducers} from 'redux';

import {availabilityReducer} from '@/redux/v1/availability/reducer';
import {hotelsReducer} from '@/redux/v1/hotels/reducer';
import {reducer as keywordDataReducer} from '@/redux/v1/keywordData/reducer';
import {reducer as offerAlternativeFlightsReducer} from '@/redux/v1/offerAlternativeFlights/reducer';
import {offersReducer} from '@/redux/v1/offers/reducer';
import {reducer as offerUpsellingReducer} from '@/redux/v1/offerUpselling/reducer';

export const v1Reducer = combineReducers({
  hotels: hotelsReducer,
  offers: offersReducer,
  availability: availabilityReducer,
  keywordData: keywordDataReducer,
  newsletter: newsletterReducer,
  offerUpselling: offerUpsellingReducer,
  offerAlternativeFlights: offerAlternativeFlightsReducer,
  wishlistMeta: wishlistMetaReducer,
});
